<template>
    <div v-click-outside="onClickOutside" class="single-select">
        <div class="single-select__trigger" :class="{ isActive: dropdown }" @click="toggleDropdown">
            <span class="single-select__title">{{data.displayname}}</span>
            <span class="single-select__value" :class="{hidden: data.checkedFilters.length == 0}">{{data.checkedFilters[0]}}</span>
            <span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129">
            <path d="M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z"
            />
          </svg>
          </span>
        </div>
        <div ref="dropdown" class="single-select__dropdown" :class="{ activeSearch: showLoader }">
            <div class="single-select__search-wrapp" :class="{hidden: data.filters.length < 6}">
                <input type="text" ref="txt_search" v-model="search">
            </div>
            <div>
                <ul class="single-select__filters-wrapp">
                    <li v-for="(filter, index) in filteredList" :class="{selected:filter == data.checkedFilters[0]}" @click="selectItem(index)">
                        {{filter}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style scoped>
    @media only screen and (max-width: 600px) {
        body {
            display: block;
        }
    }
    
    * {
        outline: none;
        -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    }
    
    *,
    :after,
    :before {
        box-sizing: border-box;
    }
    
    textarea,
    input {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border-radius: 0;
    }
    
    .single-select {
        position: relative;
        width: 100%;
        padding-right: 18px;
        padding-left: 1px;
    }
    
    @media only screen and (max-width: 600px) {
        .single-select {
            margin: 100px auto 0;
        }
    }
    
    .single-select__trigger {
        border-radius: 4px;
        background: #fff repeat;
        position: relative;
        z-index: 1;
        box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.10);
        height: 27px;
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 0px 8px 0px 20px;
        transition: all 0.4s ease;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    
    @media only screen and (max-width: 600px) {
        .single-select__trigger {
            padding: 0 15px;
            height: 70px;
        }
    }
    
    .single-select__trigger.isActive {
        border-radius: 4px 4px 0 0;
    }
    
    .single-select__trigger.isActive svg {
        transform: rotate(-180deg);
    }
    
    .single-select__trigger:hover {
        /*background: #f4f4f4 repeat;*/
    }
    
    .single-select__trigger svg {
        width: 10px;
        stroke: 4px;
        transition: all 0.4s ease;
        vertical-align: middle;
    }
    
    @media only screen and (max-width: 600px) {
        .single-select__trigger svg {
            width: 22px;
        }
    }
    
    .single-select__title {
        flex: 1;
        padding-right: 12px;
        letter-spacing: 1px;
    }
    
    .single-select__value {
        padding-right: 12px;
    }
    
    .single-select__title_selected {
        padding-right: 5px;
    }
    
    @media only screen and (max-width: 600px) {
        .single-select__title {
            font-size: 12px;
        }
    }
    
    .single-select__dropdown {
        opacity: 0;
        visibility: hidden;
        background: #fff repeat;
        position: absolute;
        left: 0;
        right: 0;
        box-shadow: 0 12px 15px 6px rgba(0, 0, 0, 0.1);
        border-radius: 0 0 4px 4px;
        border: 1px solid #d4d4d4;
        overflow: hidden;
        padding-bottom: 1px;
        margin-right: 17px;
        z-index: 999;
    }
    
    .single-select__search-wrapp {
        padding: 2px 4px 2px;
        margin: 0px 10px;
    }
    
    @media only screen and (max-width: 600px) {
        .single-select__search-wrapp {
            padding: 10px 15px 5px;
        }
    }
    
    .single-select__search-wrapp input {
        width: 100%;
        height: 24px;
        border-width: 0 0 1px;
        border-style: solid;
        border-color: gray;
        background: transparent;
    }
    
    .single-select__search-wrapp::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        color: #b8b8b8;
        opacity: 1;
    }
    
    .single-select__search-wrapp::-moz-placeholder {
        /* Firefox 19+ */
        color: #b8b8b8;
        opacity: 1;
    }
    
    .single-select__search-wrapp:-ms-input-placeholder {
        /* IE 10+ */
        color: #b8b8b8;
        opacity: 1;
    }
    
    .single-select__search-wrapp:-moz-placeholder {
        /* Firefox 18- */
        color: #b8b8b8;
        opacity: 1;
    }
    
    .single-select__col {
        display: flex;
        font-size: 12px;
        padding: 4 17px;
        justify-content: space-between;
        text-transform: uppercase;
    }
    
    @media only screen and (max-width: 600px) {
        .single-select__col {
            padding: 0 12px;
        }
    }
    
    .single-select__select-all {
        padding-left: 14px;
        padding-top: 7px;
        padding-bottom: 5px;
    }
    
    .single-select__select-all label {
        cursor: pointer;
    }
    
    .single-select__filters-wrapp {
        padding: 0px;
        height: 180px;
        overflow-y: auto;
        top: 0;
        left: 0;
        z-index: 10;
        margin: 0;
        border-radius: 4px;
    }
    
    .single-select__filters-wrapp li {
        list-style: none;
        line-height: 27px;
        padding: 0 20px;
        margin: 0;
        font-size: 12px;
        color: #606266;
        cursor: pointer;
        outline: none;
    }
    
    .single-select__filters-wrapp li:hover {
        color: #000;
        background: #d5d5d5;
    }
    
    .single-select__filters-wrapp li.selected {
        color: #000;
        /*background: #d0d0d0;*/
    }
    
    .single-select__check-wrapp {
        position: relative;
        padding: 0 25px;
        margin-bottom: 5px;
    }
    
    @media only screen and (max-width: 600px) {
        .single-select__check-wrapp {
            padding: 0 15px;
        }
    }
    
    .single-select__check-wrapp input[type="checkbox"] {
        display: none;
    }
    
    .single-select__check-wrapp input[type="checkbox"] + label {
        position: relative;
        cursor: pointer;
        font-size: 12px;
        line-height: 26px;
        padding-left: 30px;
        display: inline-block;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        transition: padding 0.25s ease;
    }
    
    .single-select__check-wrapp input[type="checkbox"] + label:after {
        border: solid 1px gray;
        content: "";
        width: 20px;
        height: 20px;
        top: 0;
        left: 0;
        position: absolute;
    }
    
    .single-select__check-wrapp input[type="checkbox"] + label:before {
        width: 14px;
        height: 14px;
        content: "";
        position: absolute;
        top: 0px;
        left: 4.3px;
        opacity: 0;
        will-change: transform;
        transform: scale(0.5);
        transition: all 0.2s ease;
    }
    
    .single-select__check-wrapp input[type="checkbox"] + label:hover {
        padding-left: 32px;
    }
    
    .single-select__check-wrapp input[type="checkbox"]:checked + label:before {
        opacity: 1;
        transform: scale(1);
    }
    
    @keyframes load {
        0% {
            left: -200px;
            width: 20%;
        }
        50% {
            width: 40%;
        }
        70% {
            width: 60%;
        }
        80% {
            left: 50%;
        }
        95% {
            left: 120%;
        }
        100% {
            left: 100%;
        }
    }
    
    .link {
        position: absolute;
        left: 0;
        bottom: 0;
        padding: 20px;
        z-index: 9999;
    }
    
    .link a {
        display: flex;
        align-items: center;
        text-decoration: none;
        color: #fff;
    }
    
    .link .fa {
        font-size: 28px;
        margin-right: 8px;
        color: #fff;
    }
</style>
<script>
import Vue from 'vue'
import {TweenMax, Power2} from "gsap/TweenMax"
import vClickOutside from 'v-click-outside'

Vue.use(vClickOutside)

export default {
  props: ['data', 'callback'],
  data() {
    return {
      search: "",
      dropdown: false,
      showLoader: false,
      selectedItem: ''
    };
  },
  computed:{
    filteredList() {
      return this.data.filters.filter(item => {
        return item.toLowerCase().includes(this.search.toLowerCase())
      });
    }
  },
  mounted: function() {

  },
  components: {
  },
  methods: {    
    selectItem: function(index) {
      this.selectedItem = this.filteredList[index]
      this.data.checkedFilters = []
      this.data.checkedFilters.push(this.selectedItem)
      this.toggleDropdown()
    },
    toggleDropdown: function(){
        var _self = this
        if(this.dropdown == false){
            this.dropdown = true;
            TweenMax.fromTo(
                this.$refs.dropdown,
                0.55,
                {
                autoAlpha: 0,
                y: -10
                },
                {
                autoAlpha: 1,
                y: 0,
                ease: Power2.easeOut,
                onComplete: function(){
                    _self.$refs.txt_search.focus()
                }
                }
            )
        }else{
            this.dropdown = false;
            this.activeTrigger = false;
            TweenMax.to(
                this.$refs.dropdown,
                0.2,
                {
                autoAlpha: 0,
                y: -10,
                ease: Power2.easeOut,
                onComplete: function(){
                    if (_self.data.callback == 'true' && _self.callback) {
                        _self.callback(_self.data)
                    }
                  }
                });
        }
    },
    onClickOutside: function(event) {
        if(this.dropdown == true){
            this.toggleDropdown()
        }
    }
  }
}
</script>


// WEBPACK FOOTER //
// SingleSelect.vue?75c57c0a